// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__33qw8","link":"Item_link__12R0g","active":"Item_active__q2-fG"};